(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWcheetah_atlas_", frames: [[428,1470,126,108],[684,1476,118,112],[310,1356,116,120],[794,1356,116,118],[98,1408,116,118],[506,1234,126,110],[556,1472,126,108],[350,638,160,304],[188,638,160,304],[0,748,160,304],[162,944,172,234],[564,356,138,192],[0,1310,96,156],[218,1352,90,164],[940,564,74,140],[650,1350,142,120],[506,1348,142,120],[362,1234,142,120],[218,1224,142,126],[722,846,168,244],[564,564,186,280],[752,564,186,280],[708,0,186,280],[376,356,186,280],[0,466,186,280],[708,282,186,280],[188,356,186,280],[0,184,186,280],[354,178,352,176],[354,0,352,176],[0,0,352,182],[852,1128,106,226],[110,1180,106,226],[896,0,118,280],[896,282,118,280],[336,944,118,278],[892,846,118,280],[634,1092,108,254],[0,1054,108,254],[744,1092,106,256],[188,184,150,156],[512,846,208,208],[456,1056,176,176]]}
];


// symbols:



(lib.CheetahHead_001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHead_002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHead_003 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHead_003_wet = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHead_excited_001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHead_excited_002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHead_excited_003 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHindLeg0001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHindLeg0002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHindLeg_excited_001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHindLeg_excited_004 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CheetahHindLeg_excited_005 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CheetahLegA_090 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CheetahLegA_091 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CheetahLegB_096 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CheetahNeck0001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CheetahNeck0002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CheetahNeck_excited_001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CheetahNeck_wet0002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTail = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTail_loop0001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTail_loop0002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTail_loop0003 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTail_loop0004 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTail_loop0005 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTail_loop0006 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTail_loop0007 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTail_loop0008 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTorso0002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTorso_excited_001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.CheetahTorso_wet0002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.FrontLegBack0001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.FrontLegBack0002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.FrontLeg0001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.FrontLeg0002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.FrontLeg_excited_001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.FrontLeg_excited_003 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.HindLegBack0001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.HindLegBack0002 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.HindLegBack_excited_001 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.HindLegBack_excited_005 = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWcheetah_atlas_"];
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.CheetahLegB_096_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahLegB_096();
	this.instance.parent = this;
	this.instance.setTransform(-5.5,-3.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahLegB_096_1, new cjs.Rectangle(-5.5,-3.9,37,70), null);


(lib.CheetahLegA_091_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahLegA_091();
	this.instance.parent = this;
	this.instance.setTransform(-4.5,-3.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahLegA_091_1, new cjs.Rectangle(-4.5,-3.9,45,82), null);


(lib.CheetahLegA_090_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.CheetahLegA_090();
	this.instance.parent = this;
	this.instance.setTransform(-4.5,-3.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahLegA_090_1, new cjs.Rectangle(-4.5,-3.9,48,78), null);


(lib.cheetah_tummyGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(5,1,1).p("AFpgyQAMgiANhCQjtAkkbArQiOAWhiAdQgRAwAIAoQAEATAHALIBUAgQAOAEAQAEQAJADAJACIAnAGQAKABAKAAQAPABAPAAIBwgPQADgBADgBQAhgKArgaIBBgsQAJgHAIgFQA9gqA+gZQA+gcAzADg");
	this.shape.setTransform(59.1,9.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.cheetah_tummyGlow, new cjs.Rectangle(17.9,-7.7,82.3,35.2), null);


(lib.cheetah_neckGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(5,1,1).p("ADaiVQAHgJgoACIheAAQgxgBg8gTQgegJgRgEQADAWgNA9QgMA9g7AtQg8AsgMALQAOACAiANQA6AVAVAKQAUAMAcAmQAcAnAJAAQAdAAAthGQA9heADgDQABgCACgCQAAAAAAAAQABgDAagzQAcg3AGgOQAQgkAGgJg");
	this.shape.setTransform(26.1,19.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.cheetah_neckGlow, new cjs.Rectangle(1.7,-2.2,48.8,42.9), null);


(lib.cheetah_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(5,1,1).p("AI9oMQg5gNhCAAQgzgGghAZQgaAdgEAWQgEAWgKAuQgLAugCCjIhAAAQgBASAAASQABB7BBBBQAWAXA3A3QA0A0AgAmQADAJACAEQgEArgIAhQgHAbgJAUQgEAJgGAJQgMAVgVAWIAAAAQgFAAgFAAQgHAAgGACQgCgBgBAAQgIAAgGABQgPgBgIAFQgDACgBACIgBAAQgIAFgCAOQAAAAAAABQgEACgEACQgBAAAAAAQAGADADAAQAAABABABQgDABgCACIgBABQAEABADABQABABAAAAQADAEADACIAAAAIAAABQAGAEAHABQACAAACABQAEABAFABQALAJAWABQAFAAAGAAQARADANAAQAPABAPgCQAbgDADgBQAQgBANgYQASgnAQgdQAFgJAGgKQARgfAPgiQAEgIADgIQAPghAGgTQAEAEAEAEIASAUQABACABABQAGAEADAIQgBANAAAMQgDAkgDAdQgNBwgTALQgCABgDABQgGgDgLgBQgUgBgLAGQgDABgCACIgBAAQgKAGgDAPQAAABAAABQgIAGgFAIIgBABQAGACAJgCQABABABACQACACACADQgDACgCADIAAABQAGAFALgFQABAAABABQAFADAFACQgBACgBACQgDABAAABQAOAHALgEQAWALAvgIQABgBACAAQAQgBAZgHQAEgBAEgBQAVgGAJgEQADgCARhGQAJgpAOg/QAAgBAAgBQAFgMAFgUQAGgVACgMQABgIAAgEQANgpgPgdQgTgPgVgVQgbgbgggkQg5hAgPgVQgPgTALg/QAXgvAMgtQAxizg1hkQgshTg5gNgAq4HEQhKAAgNgKQgEgBgDgBIAAAAQgMABgIgGIAAAAQABgBABAAQgDgDgDgDQgEgBgFgCIABgBQADgCACgBQAAgBAAgCQgDABgFgCQAAgCAAAAQAEgBADgBQAAgCAAgCQACgOAIgFIABAAQABgCADgBQAHgFANAAQADgBADgBIAnggQA0g+ABiEQAAgmgGhPQgBgHAAgHQgEg8gFggQgFgmgQhiQgCgRgCgNQAWATAnAjQgbi1AJgqQAAgBAAgCQAQg/ApgsQBQhYB4BcQAwAmAAA/QAAAdgLAwQgOA+gbBMQgaBJgIBjQgCAVgBAYQgBAoABAwQgCAdgFAkQgDAPgCANQgLAzgQAdQgJASgYA6QgeBLgFAeQgJAxgeASQgEABgWAFQgBAAAAABQgEACgEACQgHAAgGABQgCAAgBAAQgCAAgDAAQgagBgPgIQgNAHgOgJQABgBAAgBQADgEADgEQgGgCgDgDQgBABAAAAQgMAIgJgHIAAgBQAEgFAFgEQgEgDgDgFQAAACgBABQgLAEgFgDIAAgBQAEgHAJgHQABAAAAABQAAgFABgGQADgPALgEQACgCACgB");
	this.shape.setTransform(-30.8,53.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.cheetah_legGlow, new cjs.Rectangle(-115.9,-4.4,170.3,116.6), null);


(lib.cheetah_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(5,1,1).p("AImiQQgwg/hAgFQhKgGhcAdIhMAeIgDABQgdAPhsAbQhrAciFgSQiFgSgwgQQhGgYg9gUQg9gTAJDAQAJC/EBATQDgAoFOhCQAWgEAJgjQAIgwAGgdQAWhyBegeQAIgLBpgug");
	this.shape.setTransform(79,21.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.cheetah_backGlow, new cjs.Rectangle(21.5,-2.6,115,47.9), null);


(lib.blueglowtummy = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("AFpgyQAMgiANhCQjtAkkbArQiOAWhiAdQgRAwAIAoQAEATAHALIBUAgQAOAEAQAEQAJADAJACIAnAGQAKABAKAAQAPABAPAAIBwgPQADgBADgBQAhgKArgaIBBgsQAJgHAIgFQA9gqA+gZQA+gcAzADg");
	this.shape.setTransform(59.1,9.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtummy, new cjs.Rectangle(17.9,-7.7,82.3,35.2), null);


(lib.blueglowneck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("ADaiVQAHgJgoACIheAAQgxgBg8gTQgegJgRgEQADAWgNA9QgMA9g7AtQg8AsgMALQAOACAiANQA6AVAVAKQAUAMAcAmQAcAnAJAAQAdAAAthGQA9heADgDQABgCACgCQAAAAAAAAQABgDAagzQAcg3AGgOQAQgkAGgJg");
	this.shape.setTransform(26.1,19.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowneck, new cjs.Rectangle(1.7,-2.2,48.8,42.9), null);


(lib.blueglowlegs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("AI9oMQg5gNhCAAQgzgGghAZQgaAdgEAWQgEAWgKAuQgLAugCCjIhAAAQgBASAAASQABB7BBBBQAWAXA3A3QA0A0AgAmQADAJACAEQgEArgIAhQgHAbgJAUQgEAJgGAJQgMAVgVAWIAAAAQgFAAgFAAQgHAAgGACQgCgBgBAAQgIAAgGABQgPgBgIAFQgDACgBACIgBAAQgIAFgCAOQAAAAAAABQgEACgEACQgBAAAAAAQAGADADAAQAAABABABQgDABgCACIgBABQAEABADABQABABAAAAQADAEADACIAAAAIAAABQAGAEAHABQACAAACABQAEABAFABQALAJAWABQAFAAAGAAQARADANAAQAPABAPgCQAbgDADgBQAQgBANgYQASgnAQgdQAFgJAGgKQARgfAPgiQAEgIADgIQAPghAGgTQAEAEAEAEIASAUQABACABABQAGAEADAIQgBANAAAMQgDAkgDAdQgNBwgTALQgCABgDABQgGgDgLgBQgUgBgLAGQgDABgCACIgBAAQgKAGgDAPQAAABAAABQgIAGgFAIIgBABQAGACAJgCQABABABACQACACACADQgDACgCADIAAABQAGAFALgFQABAAABABQAFADAFACQgBACgBACQgDABAAABQAOAHALgEQAWALAvgIQABgBACAAQAQgBAZgHQAEgBAEgBQAVgGAJgEQADgCARhGQAJgpAOg/QAAgBAAgBQAFgMAFgUQAGgVACgMQABgIAAgEQANgpgPgdQgTgPgVgVQgbgbgggkQg5hAgPgVQgPgTALg/QAXgvAMgtQAxizg1hkQgshTg5gNgAq4HEQhKAAgNgKQgEgBgDgBIAAAAQgMABgIgGIAAAAQABgBABAAQgDgDgDgDQgEgBgFgCIABgBQADgCACgBQAAgBAAgCQgDABgFgCQAAgCAAAAQAEgBADgBQAAgCAAgCQACgOAIgFIABAAQABgCADgBQAHgFANAAQADgBADgBIAnggQA0g+ABiEQAAgmgGhPQgBgHAAgHQgEg8gFggQgFgmgQhiQgCgRgCgNQAWATAnAjQgbi1AJgqQAAgBAAgCQAQg/ApgsQBQhYB4BcQAwAmAAA/QAAAdgLAwQgOA+gbBMQgaBJgIBjQgCAVgBAYQgBAoABAwQgCAdgFAkQgDAPgCANQgLAzgQAdQgJASgYA6QgeBLgFAeQgJAxgeASQgEABgWAFQgBAAAAABQgEACgEACQgHAAgGABQgCAAgBAAQgCAAgDAAQgagBgPgIQgNAHgOgJQABgBAAgBQADgEADgEQgGgCgDgDQgBABAAAAQgMAIgJgHIAAgBQAEgFAFgEQgEgDgDgFQAAACgBABQgLAEgFgDIAAgBQAEgHAJgHQABAAAAABQAAgFABgGQADgPALgEQACgCACgB");
	this.shape.setTransform(-30.8,53.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowlegs, new cjs.Rectangle(-115.9,-4.4,170.3,116.6), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("AImiQQgwg/hAgFQhKgGhcAdIhMAeIgDABQgdAPhsAbQhrAciFgSQiFgSgwgQQhGgYg9gUQg9gTAJDAQAJC/EBATQDgAoFOhCQAWgEAJgjQAIgwAGgdQAWhyBegeQAIgLBpgug");
	this.shape.setTransform(79,21.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(21.5,-2.6,115,47.9), null);


(lib.HindLegBack_excited_005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.HindLegBack_excited_005();
	this.instance.parent = this;
	this.instance.setTransform(-71.5,-6.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.HindLegBack_excited_005_1, new cjs.Rectangle(-71.5,-6.9,75,78), null);


(lib.HindLegBack_excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.HindLegBack_excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-59,-56.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.HindLegBack_excited_001_1, new cjs.Rectangle(-59,-56.4,53,128), null);


(lib.FrontLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:270,"final":271,final_loop:272});

	// Layer 6
	this.instance = new lib.FrontLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(-20.4,-51.4,0.5,0.5);

	this.instance_1 = new lib.FrontLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-20.4,-51.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},267).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-38.8,-51.4,71.4,113);


(lib.FrontLeg_excited_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.FrontLeg_excited_003();
	this.instance.parent = this;
	this.instance.setTransform(-21,-64.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.FrontLeg_excited_003_1, new cjs.Rectangle(-21,-64.4,59,140), null);


(lib.FrontLeg_excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.FrontLeg_excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-21,-64.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.FrontLeg_excited_001_1, new cjs.Rectangle(-21,-64.4,59,139), null);


(lib.CheetahTorso_wet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,"final_loop":1});

	// Layer 5
	this.instance = new lib.CheetahTorso_wet0002();
	this.instance.parent = this;
	this.instance.setTransform(-83,-37.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-83,-100.3,176,153.4);


(lib.CheetahTorso_excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahTorso_excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-83,-38.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahTorso_excited_001_1, new cjs.Rectangle(-83,-38.4,176,88), null);


(lib.CheetahTail_loop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.CheetahTail_loop0001();
	this.instance.parent = this;
	this.instance.setTransform(-37,-56.5,0.5,0.5);

	this.instance_1 = new lib.CheetahTail_loop0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-37,-56.5,0.5,0.5);

	this.instance_2 = new lib.CheetahTail_loop0003();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-37,-56.5,0.5,0.5);

	this.instance_3 = new lib.CheetahTail_loop0004();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-37,-56.5,0.5,0.5);

	this.instance_4 = new lib.CheetahTail_loop0005();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-37,-56.5,0.5,0.5);

	this.instance_5 = new lib.CheetahTail_loop0006();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-37,-56.5,0.5,0.5);

	this.instance_6 = new lib.CheetahTail_loop0007();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-37,-56.5,0.5,0.5);

	this.instance_7 = new lib.CheetahTail_loop0008();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-37,-56.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-37,-56.5,93,140);


(lib.CheetahTail_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.CheetahTail();
	this.instance.parent = this;
	this.instance.setTransform(-38.9,-56.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahTail_1, new cjs.Rectangle(-38.9,-56.9,84,122), null);


(lib.CheetahNeck_wet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,"final_loop":1});

	// Layer 4
	this.instance = new lib.CheetahNeck_wet0002();
	this.instance.parent = this;
	this.instance.setTransform(-30.5,-24.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-30.5,-24.9,71,63);


(lib.CheetahNeck_excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahNeck_excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-30.5,-24.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahNeck_excited_001_1, new cjs.Rectangle(-30.5,-24.9,71,60), null);


(lib.CheetahHindLeg_excited_005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.CheetahHindLeg_excited_005();
	this.instance.parent = this;
	this.instance.setTransform(-30,-16.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahHindLeg_excited_005_1, new cjs.Rectangle(-35.2,-16.4,78,96), null);


(lib.CheetahHindLeg_excited_004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.CheetahHindLeg_excited_004();
	this.instance.parent = this;
	this.instance.setTransform(-47.9,-37.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahHindLeg_excited_004_1, new cjs.Rectangle(-47.9,-40.8,86,119.9), null);


(lib.CheetahHindLeg_excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.CheetahHindLeg_excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-41.5,-72.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahHindLeg_excited_001_1, new cjs.Rectangle(-41.5,-72.9,80,152), null);


(lib.CheetahHead_excited_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahHead_excited_003();
	this.instance.parent = this;
	this.instance.setTransform(-23.5,-27.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahHead_excited_003_1, new cjs.Rectangle(-24.3,-29.1,63.9,55.2), null);


(lib.CheetahHead_excited_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahHead_excited_002();
	this.instance.parent = this;
	this.instance.setTransform(-23.5,-27.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahHead_excited_002_1, new cjs.Rectangle(-24.3,-29.1,63.9,56.2), null);


(lib.CheetahHead_excited_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahHead_excited_001();
	this.instance.parent = this;
	this.instance.setTransform(-25.5,-29.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahHead_excited_001_1, new cjs.Rectangle(-26.5,-30.4,59,60), null);


(lib.CheetahHead_003_wet_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahHead_003_wet();
	this.instance.parent = this;
	this.instance.setTransform(-25.5,-29.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahHead_003_wet_1, new cjs.Rectangle(-26.5,-30.4,59,60), null);


(lib.CheetahHead_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahHead_003();
	this.instance.parent = this;
	this.instance.setTransform(-25.5,-29.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahHead_003_1, new cjs.Rectangle(-26.5,-30.4,59,61), null);


(lib.CheetahHead_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahHead_002();
	this.instance.parent = this;
	this.instance.setTransform(-23.5,-27.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahHead_002_1, new cjs.Rectangle(-24.5,-29.2,60,57.3), null);


(lib.CheetahHead_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CheetahHead_001();
	this.instance.parent = this;
	this.instance.setTransform(-23.4,-28.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CheetahHead_001_1, new cjs.Rectangle(-24.3,-29.1,63.9,54.7), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.cheetah_tummyMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_loop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":81,glowclean:82,glowclean_loop:83,"final":84,"final_loop":85});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ACTCjQhHgChCgUQgfgJgegOIgFAAIgEgDIgEgBIgCgCQgJgBgJgEIgsgVQgEgFgGgDQgDgBgBgFIgFgBQgHgKgIgFQgNgJgIgKQghgTgfgUQgVgPgTgPIgFgBIAAgCIgFgCIgCgCIgBgBIgGgBIgFgEIgdgGIgCgEIgFAAIgIgFIgCAAQgjgFgfALQgegCgJgEQgUgGAAgTQAKgPARgOQAhgdAhAAQANAFADAAQACAAASgKQAUgLAIgCQAUgEAPAJQANAJADAAQADAAAGgDQAGgDAEAAQAVAAAXAiQAmA4AMAMIA6gCQAjABAbAEIAhAGQAOADBCAgIAIgCQAFgDAKAAQATAAAQAHIAPAFIAvgZQAFgCAVgCQATgBAFgEQACgBAVgZQAZgYAgAAQAbAAAKAdQAFAPACATQABAEAPADIAdAHQApALAAAiIAAAIQAVgCAKAJIgFAEQgDACgDAAIgEADIgBAEIgBAAIgMAHQgEACgBADIgIAFIgKADQgMAGgNACIgDADQgKABgKAGQgTALgSAIQgJACgIADQgIADgFADIgSACQgYAGgVAJIgQACIgKAFQgkAFglAAIgHAAg");
	this.shape.setTransform(46.8,17.6);

	this.instance = new lib.left_over_bubbles_2();
	this.instance.parent = this;
	this.instance.setTransform(41.7,18.2,0.552,0.552,70.5,0,0,48.8,4.9);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(84.2,22,0.552,0.552,-40.5,0,0,48.8,4.8);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(67.7,26.8,0.722,0.722,14.7,0,0,47.6,9.2);

	this.instance_3 = new lib.left_over_bubbles("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(56.3,22.8,0.556,0.556,-5.2,0,0,35,9.8);

	this.instance_4 = new lib.cheetah_tummyGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(43.7,16,1.25,1.25,0,0,180,59,9.9);

	this.glow = new lib.blueglowtummy();
	this.glow.parent = this;
	this.glow.setTransform(43.7,16,1.25,1.25,0,0,180,59,9.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_4}]},2).to({state:[]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},5).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},70).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},142).wait(78));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.5,1.3,96.7,32.6);


(lib.cheetah_backMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":80,"glowclean":81,"glowclean_loop":82,"final":83,"final_loop":84});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AhPC4QgJgWABgnQhsAFgagbQgNgOAFgYQgLgdgjgHQgOASgXAAQg0AAgZgpQgQgYAAgXIAAgKIgZgSQhEgzAAgcQAAgYAFgPQALgjAhAAQBSAAAxAaQAYASAPAJIAMADIA2AOIAuAEQAbAOAdAGIBKASQAkAKAmAEQAmAFApgCQAngBAjgQQAjgPAmgEQAngGAmgKQASgEAOgIQAWgHAWgGQARgEAPgGIAHgDIAAgBQAsAJAAAeQAAA4gQAgQgcA6hLAFQgJAsgPAoQgfBNhEAAQg8AAgPgYQgFgMgEgFQgGgHgNAAQgVgBg1A3Qg1A2gWAAQhEAAgQgpg");
	this.shape.setTransform(44.9,-42.8);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(21.8,-53.1,0.436,0.436,-158.3,0,0,47.8,9);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(76.8,-45.2,1,1,148.2,0,0,47.6,10);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31.5,-48.6,0.865,0.865,-153.3,0,0,50.6,5.2);

	this.instance_3 = new lib.left_over_bubbles("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(63.5,-44.2,1.031,1.031,-170.2,0,0,35.1,9.8);

	this.instance_4 = new lib.cheetah_backGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(41.9,-43.4,1,1,0,0,180,79,21.2);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(41.9,-43.4,1,1,0,0,180,79,21.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_4}]},2).to({state:[]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},6).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},68).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},143).wait(78));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4.9,-65.3,99.8,45);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.backbubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":56});

	// Layer 1
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-26.7,-5.5,0.277,0.317,-27.8,0,0,35.3,11.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-15.9,-5.3,0.479,0.413,-163,0,0,35.6,11);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-9.1,7.4,0.389,0.447,-27.8,0,0,35.2,12);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(6.3,7.9,0.389,0.447,-54.2,0,0,35.4,11.3);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(20.8,5.4,0.479,0.479,-19.4,0,0,35.8,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},55).to({state:[]},1).wait(14));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.HindLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":270,"final":271,"final_loop":272});

	// Layer 7
	this.instance = new lib.HindLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(-59,-56.4,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-35,18.5,0.5,0.5,-45,0,0,47.6,10.1);

	this.instance_2 = new lib.left_over_bubbles_2();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-42.9,33,1,1,0,90,-90,48.8,4.8);

	this.instance_3 = new lib.HindLegBack0002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-59,-56.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},12).to({state:[{t:this.instance_3}]},253).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-59,-56.4,54,127);


(lib.FrontLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":103,"glowclean":104,"glowclean_loop":105,"final":106,"final_loop":107});

	// Layer 7
	this.instance = new lib.FrontLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-21,-64.4,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(3.1,5.6,1,1,0,90,-90,47.6,10.1);

	this.instance_2 = new lib.FrontLeg0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-21,-64.4,0.5,0.5);

	this.instance_3 = new lib.cheetah_legGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-59.3,1.3,1.1,1.1,0,0,180,-30.8,53.8);

	this.glow = new lib.blueglowlegs();
	this.glow.parent = this;
	this.glow.setTransform(-59.3,1.3,1.1,1.1,0,0,180,-30.8,53.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},9).to({state:[{t:this.instance_2},{t:this.instance_1}]},88).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(168));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-38,-64.4,76,140);


(lib.CheetahTummy_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":56});

	// Layer 4
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-31.3,12.2,0.346,0.397,-27.8,0,0,35.2,11.3);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-17.9,12.5,0.598,0.516,-163,0,0,35.5,11);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-9.3,28.3,0.487,0.558,-27.8,0,0,35.2,12);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(9.8,29,0.487,0.558,-54.2,0,0,35.4,11.3);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(28,25.9,0.598,0.598,-19.4,0,0,35.7,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},55).wait(57));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CheetahTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"clean":1});

	// Layer 7
	this.tummymud = new lib.cheetah_tummyMud_001();
	this.tummymud.parent = this;
	this.tummymud.setTransform(5.5,20.7,1,1,0,0,0,48.9,18.2);

	this.backmud = new lib.cheetah_backMud_001();
	this.backmud.parent = this;
	this.backmud.setTransform(3.8,53.7,1,1,0,0,0,49.9,22.5);

	this.instance = new lib.CheetahTorso0002();
	this.instance.parent = this;
	this.instance.setTransform(-82.5,-38.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.backmud},{t:this.tummymud}]}).to({state:[{t:this.instance}]},1).to({state:[]},1).wait(271));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-82.5,-100.3,176,149.9);


(lib.CheetahNeck_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(3.4,-2,0.432,0.495,-107.7,0,0,35.5,11.3);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-8.2,-16.7,0.598,0.598,167.3,0,0,35.6,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(43));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CheetahNeck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":62,"glowclean":63,"glowclean_loop":64,"final":65,"final_loop":66});

	// neck
	this.instance = new lib.CheetahNeck0001();
	this.instance.parent = this;
	this.instance.setTransform(-30.5,-24.9,0.5,0.5);

	this.instance_1 = new lib.CheetahNeck0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-30.5,-24.9,0.5,0.5);

	this.instance_2 = new lib.cheetah_neckGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-0.8,-0.5,1,1,0,0,180,26.1,19.2);

	this.glow = new lib.blueglowneck();
	this.glow.parent = this;
	this.glow.setTransform(-0.8,-0.5,1,1,0,0,180,26.1,19.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},56).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(159));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-30.5,-24.9,71,60);


(lib.CheetahHindLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":84});

	// Layer 4
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(140.5,-29.7,0.487,0.558,-143.7,0,0,35.5,11.6);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(131.5,-52.1,0.487,0.558,150,0,0,35.6,11.3);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(122.2,-66.6,0.487,0.558,-72,0,0,35.7,11.3);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(120,-43.5,0.487,0.558,-72,0,0,35.5,11.4);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(104,-62.4,0.487,0.558,-72,0,0,35.6,11.1);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(9.6,9.9,0.487,0.558,-3,0,0,35.4,11.4);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-6.1,1.9,0.574,0.567,0,-26.6,-35.4,35.4,11);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-6.6,23.9,0.487,0.558,-54.2,0,0,35.5,11.4);

	this.instance_8 = new lib.Bubbles_together();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-1.3,-26.1,0.598,0.598,80.6,0,0,35.6,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},83).wait(43));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CheetahHindLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":270,"final":271,"final_loop":272});

	// Layer 6
	this.instance = new lib.CheetahHindLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-41.5,-72.9,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(5.9,-8.5,1,1,45,0,0,48.9,4.8);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-1.1,10,0.606,0.533,105,0,0,50.3,5.2);

	this.instance_3 = new lib.CheetahHindLeg0002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-41.5,-72.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},11).to({state:[{t:this.instance_3}]},254).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-41.5,-72.9,80,152);


(lib.water_drops_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(182.5,4.9,0.486,0.486,0,0,180,4.7,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(70,37,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(28.6,28,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(2.4,41.5,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(91.1,10.7,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(132.4,41.5,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,31.6,18,24);


(lib.Cheetah = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:40,rest_stop:186,"clean":188,clean_stop:198,wet:200,wet_stop:212,excited:214,excited_stop:290,animalSound:335});

	// timeline functions:
	this.frame_38 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_186 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_198 = function() {
		/* stop();*/
	}
	this.frame_212 = function() {
		/* stop();*/
	}
	this.frame_334 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_396 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(38).call(this.frame_38).wait(148).call(this.frame_186).wait(12).call(this.frame_198).wait(14).call(this.frame_212).wait(122).call(this.frame_334).wait(62).call(this.frame_396).wait(2));

	// drops
	this.instance = new lib.water_drops_007();
	this.instance.parent = this;
	this.instance.setTransform(423.8,96.5,0.5,0.5,0,0,180,92.4,49.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(200).to({_off:false},0).to({_off:true},14).wait(184));

	// Cheetah Neck
	this.neck_bubbles = new lib.CheetahNeck_bubbles();
	this.neck_bubbles.parent = this;
	this.neck_bubbles.setTransform(395.2,81,0.588,0.588,0,-6.2,173.8,-12.8,3.3);
	this.neck_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.neck_bubbles).wait(40).to({_off:true},160).wait(198));

	// Cheetah Hind Leg
	this.legs_bubbles = new lib.CheetahHindLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(471.4,87.9,0.561,0.526,0,-22.6,157.4,-18.4,-47.2);
	this.legs_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).wait(40).to({_off:true},160).wait(198));

	// tummy bubbles
	this.tummy_bubbles = new lib.CheetahTummy_bubbles();
	this.tummy_bubbles.parent = this;
	this.tummy_bubbles.setTransform(407.3,88.1,0.588,0.588,0,3.8,-176.2,46.5,-0.5);
	this.tummy_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.tummy_bubbles).wait(40).to({_off:true},160).wait(198));

	// Cheetah Torso
	this.back_bubbles = new lib.backbubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(432,77.5);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(40).to({_off:true},160).wait(198));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(399.6,107.2,0.679,0.679);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(330).to({_off:false},0).to({_off:true},5).wait(63));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(383.5,70,0.679,0.679);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(318).to({_off:false},0).to({_off:true},17).wait(63));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(464.9,112.9,0.679,0.679);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(300).to({_off:false},0).to({_off:true},35).wait(63));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(436.2,77.7,0.679,0.679);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(290).to({_off:false},0).to({_off:true},45).wait(63));

	// Cheetah Head
	this.instance_5 = new lib.CheetahHead_003_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(383.5,70,0.588,0.588,0,5,-175,-15.6,0.4);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_6 = new lib.CheetahHead_002_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(381.9,76.2,0.588,0.588,0,7.8,-172.2,-15.7,0.9);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_7 = new lib.CheetahHead_001_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(380.8,77.9,0.588,0.588,0,8.8,-171.2,-14.8,0.6);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);
	this.instance_7._off = true;

	this.instance_8 = new lib.CheetahHead_003_wet_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(383.5,70,0.588,0.588,0,5,-175,-15.6,0.4);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_9 = new lib.CheetahHead_excited_001_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(411.7,65.2,0.588,0.588,0,31.6,-148.4,-15.6,0.2);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_10 = new lib.CheetahHead_excited_003_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(420.8,66.8,0.588,0.588,0,49.5,-130.5,-15.7,0.4);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_11 = new lib.CheetahHead_excited_002_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(415.7,72.7,0.588,0.588,0,13.7,-166.3,-15.7,0.4);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6,p:{regX:-15.7,regY:0.9,skewX:7.8,skewY:-172.2,x:381.9}}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_7}]},14).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_6,p:{regX:-14.8,regY:0.6,skewX:8.8,skewY:-171.2,x:380.8}}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},8).to({state:[{t:this.instance_5}]},46).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6,p:{regX:-15.7,regY:0.9,skewX:7.8,skewY:-172.2,x:381.9}}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_7}]},56).to({state:[{t:this.instance_6,p:{regX:-14.8,regY:0.6,skewX:8.8,skewY:-171.2,x:380.8}}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},32).to({state:[{t:this.instance_8}]},12).to({state:[{t:this.instance_5}]},14).to({state:[{t:this.instance_5}]},8).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10,p:{regX:-15.7,skewX:49.5,skewY:-130.5,x:420.8,y:66.8}}]},2).to({state:[{t:this.instance_10,p:{regX:-15.7,skewX:49.5,skewY:-130.5,x:420.8,y:66.8}}]},32).to({state:[{t:this.instance_10,p:{regX:-15.6,skewX:31.6,skewY:-148.4,x:418.3,y:69.8}}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},49).to({state:[]},62).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(2).to({skewX:5.8,skewY:-174.2,x:383,y:72.2},0).wait(2).to({regX:-15.7,regY:0.6,skewX:6.8,skewY:-173.2,x:382.4,y:74.2},0).to({_off:true},2).wait(24).to({_off:false,regX:-15.6,regY:0.4,skewX:8.8,skewY:-171.2,x:381.2,y:73.4},0).wait(2).to({skewX:5,skewY:-175,x:383.5,y:70},0).wait(56).to({skewX:5.8,skewY:-174.2,x:383,y:72.2},0).wait(2).to({regX:-15.7,regY:0.6,skewX:6.8,skewY:-173.2,x:382.4,y:74.2},0).to({_off:true},2).wait(62).to({_off:false,regX:-15.6,regY:0.4,skewX:8.8,skewY:-171.2,x:381.2,y:73.4},0).wait(2).to({skewX:5,skewY:-175,x:383.5,y:70},0).wait(32).to({_off:true},12).wait(14).to({_off:false},0).wait(10).to({regX:-15.7,regY:0.1,skewX:-13,skewY:-193,x:382,y:79.7},0).wait(2).to({regX:-15.6,regY:0.3,skewX:-31.3,skewY:-211.3,x:380.4,y:89.9},0).wait(2).to({regY:0.4,skewX:5,skewY:-175,x:383.5,y:70},0).wait(2).to({regX:-15.8,regY:0.2,skewX:9.3,skewY:-170.7,x:393.1,y:66.7},0).wait(2).to({regX:-15.6,regY:0.1,skewX:14,skewY:-166,x:402.4,y:63.6},0).to({_off:true},2).wait(42).to({_off:false},0).wait(2).to({regX:-15.5,regY:0.3,skewX:9.3,skewY:-170.7,x:392.9,y:66.9},0).wait(2).to({regX:-15.6,regY:0.4,skewX:5,skewY:-175,x:383.5,y:70},0).wait(2).to({skewX:-25.8,skewY:-205.8,x:381.4,y:80.6},0).wait(2).to({regX:-15.3,regY:0.1,skewX:-10.3,skewY:-190.3,x:382.3,y:75.2},0).wait(2).to({regX:-15.6,regY:0.4,skewX:5,skewY:-175,x:383.5,y:70},0).wait(49).to({_off:true},62).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(8).to({_off:false},0).wait(18).to({_off:true},2).wait(66).to({_off:false},0).wait(56).to({_off:true},2).wait(122).to({_off:false,regX:-15.7,regY:0.5,skewX:13.8,skewY:-166.2,x:409,y:68.2},0).to({_off:true},2).wait(122));

	// Front Leg
	this.cheetah_frontleg = new lib.FrontLeg();
	this.cheetah_frontleg.parent = this;
	this.cheetah_frontleg.setTransform(405.5,81,0.588,0.588,0,5,-175,-1.2,-43.1);
	this.cheetah_frontleg.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.cheetah_frontleg_1 = new lib.FrontLeg_excited_001_1();
	this.cheetah_frontleg_1.parent = this;
	this.cheetah_frontleg_1.setTransform(397,141,0.588,0.588,0,5,-175,4.4,59.7);
	this.cheetah_frontleg_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.cheetah_frontleg_1._off = true;

	this.cheetah_frontleg_2 = new lib.CheetahLegA_091_1();
	this.cheetah_frontleg_2.parent = this;
	this.cheetah_frontleg_2.setTransform(399.1,141.1,1.058,0.893,0,-4,0,14.3,63.4);
	this.cheetah_frontleg_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.cheetah_frontleg_3 = new lib.FrontLeg_excited_003_1();
	this.cheetah_frontleg_3.parent = this;
	this.cheetah_frontleg_3.setTransform(413.1,78.9,0.588,0.588,0,10,-170,-1.2,-43.1);
	this.cheetah_frontleg_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.cheetah_frontleg_4 = new lib.CheetahLegA_090_1();
	this.cheetah_frontleg_4.parent = this;
	this.cheetah_frontleg_4.setTransform(410.6,100.8,1.058,1.058,12.5,0,0,14.6,32.4);
	this.cheetah_frontleg_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cheetah_frontleg}]}).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},14).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},8).to({state:[{t:this.cheetah_frontleg}]},46).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},56).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},32).to({state:[{t:this.cheetah_frontleg}]},12).to({state:[{t:this.cheetah_frontleg_1}]},14).to({state:[{t:this.cheetah_frontleg_1}]},8).to({state:[{t:this.cheetah_frontleg_1}]},2).to({state:[{t:this.cheetah_frontleg_2,p:{regX:14.3,scaleY:0.893,skewX:-4,x:399.1}}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg_3}]},2).to({state:[{t:this.cheetah_frontleg_4,p:{rotation:12.5,x:410.6,y:100.8}}]},2).to({state:[{t:this.cheetah_frontleg_4,p:{rotation:-9.2,x:429.8,y:105.5}}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},32).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg_4,p:{rotation:-9.2,x:429.8,y:105.5}}]},2).to({state:[{t:this.cheetah_frontleg_4,p:{rotation:12.5,x:410.6,y:100.8}}]},2).to({state:[{t:this.cheetah_frontleg_3}]},2).to({state:[{t:this.cheetah_frontleg}]},2).to({state:[{t:this.cheetah_frontleg_2,p:{regX:14.8,scaleY:0.962,skewX:-1.5,x:399.6}}]},2).to({state:[{t:this.cheetah_frontleg_1}]},2).to({state:[{t:this.cheetah_frontleg_1}]},2).to({state:[{t:this.cheetah_frontleg_1}]},49).to({state:[]},62).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_frontleg).wait(2).to({regX:-1,regY:-43.5,scaleY:0.58,skewY:-175.2,x:405.4,y:81.5},0).wait(2).to({regY:-42.9,scaleY:0.58,y:82.5},0).wait(2).to({regY:-43.1,scaleY:0.57,y:83.1},0).wait(2).to({regX:-1.2,scaleY:0.56,skewX:5.2,x:405.5,y:83.7},0).wait(16).to({skewX:5.1},0).wait(2).to({skewX:5.2},0).wait(2).to({regY:-43,scaleY:0.57,skewX:5,y:82.8},0).wait(2).to({regX:-1.7,regY:-42.8,scaleY:0.58,x:405.8,y:82.1},0).wait(2).to({regX:-1.2,regY:-43.1,scaleY:0.59,skewY:-175,x:405.5,y:81},0).wait(56).to({regX:-1,regY:-43.5,scaleY:0.58,skewY:-175.2,x:405.4,y:81.5},0).wait(2).to({regY:-42.9,scaleY:0.58,y:82.5},0).wait(2).to({regY:-43.1,scaleY:0.57,y:83.1},0).wait(2).to({regX:-1.2,scaleY:0.56,skewX:5.2,x:405.5,y:83.7},0).wait(58).to({regY:-43,scaleY:0.57,skewX:5,y:82.8},0).wait(2).to({regX:-1.3,regY:-43.1,scaleY:0.58,x:405.6,y:81.9},0).wait(2).to({regX:-1.2,scaleY:0.59,skewY:-175,x:405.5,y:81},0).wait(44).to({_off:true},14).wait(14).to({_off:false},0).to({_off:true},2).wait(6).to({_off:false,regX:-1.1,scaleX:0.6,skewX:-4.9,skewY:-175.1,x:433.1,y:83},0).wait(34).to({scaleX:0.6,scaleY:0.58,skewX:-5.6,skewY:-175.2,x:432.3,y:84.4},0).wait(2).to({regX:-1,scaleY:0.56,skewX:-6.5,skewY:-175.3,x:431.6,y:85.8},0).to({_off:true},2).wait(6).to({_off:false,regX:-1.2,scaleX:0.59,scaleY:0.59,skewX:5,skewY:-175,x:405.5,y:81},0).to({_off:true},2).wait(116));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_frontleg_1).wait(214).to({_off:false},0).wait(10).to({regY:59.5,scaleY:0.54,y:140.9},0).to({_off:true},2).wait(58).to({_off:false},0).wait(2).to({regY:59.7,scaleY:0.59,y:141},0).wait(49).to({_off:true},62).wait(1));

	// Cheetah Neck
	this.cheetah_neck = new lib.CheetahNeck();
	this.cheetah_neck.parent = this;
	this.cheetah_neck.setTransform(396.2,78.2,0.588,0.588,0,5,-175,-12.7,3.5);
	this.cheetah_neck.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.cheetah_neck_1 = new lib.CheetahNeck_wet();
	this.cheetah_neck_1.parent = this;
	this.cheetah_neck_1.setTransform(396.2,78.2,0.588,0.588,0,5,-175,-12.7,3.5);
	this.cheetah_neck_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.cheetah_neck_2 = new lib.CheetahNeck_excited_001_1();
	this.cheetah_neck_2.parent = this;
	this.cheetah_neck_2.setTransform(396.2,78.2,0.588,0.588,0,5,-175,-12.7,3.5);
	this.cheetah_neck_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.cheetah_neck_2._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cheetah_neck}]}).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},14).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},8).to({state:[{t:this.cheetah_neck}]},46).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},56).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},2).to({state:[{t:this.cheetah_neck}]},32).to({state:[{t:this.cheetah_neck_1}]},12).to({state:[{t:this.cheetah_neck_2}]},14).to({state:[{t:this.cheetah_neck_2}]},8).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},32).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},2).to({state:[{t:this.cheetah_neck_2}]},49).to({state:[]},62).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_neck).wait(2).to({regX:-16.2,regY:3.1,skewX:2.1,skewY:-177.9,x:398,y:78.7},0).wait(2).to({regX:-12.6,regY:3.4,skewX:-0.5,skewY:-180.5,x:395.7,y:79.5},0).wait(2).to({regX:-12.7,skewX:-3.3,skewY:-183.3,x:395.5,y:80.3},0).wait(2).to({regX:-12.8,regY:3.3,skewX:-6.2,skewY:-186.2,x:395.2,y:81},0).wait(16).to({regY:3.5,skewX:-6,skewY:-186,y:81.1},0).wait(2).to({regY:3.3,skewX:-6.2,skewY:-186.2,y:81},0).wait(2).to({regX:-13,skewX:-2.3,skewY:-182.3,x:395.6,y:80},0).wait(2).to({regX:-12.8,regY:3.4,skewX:1.3,skewY:-178.7,x:395.9,y:79.1},0).wait(2).to({regX:-12.7,regY:3.5,skewX:5,skewY:-175,x:396.2,y:78.2},0).wait(56).to({regX:-16.2,regY:3.1,skewX:2.1,skewY:-177.9,x:398,y:78.7},0).wait(2).to({regX:-12.6,regY:3.4,skewX:-0.5,skewY:-180.5,x:395.7,y:79.5},0).wait(2).to({regX:-12.7,skewX:-3.3,skewY:-183.3,x:395.5,y:80.3},0).wait(2).to({regX:-12.8,regY:3.3,skewX:-6.2,skewY:-186.2,x:395.2,y:81},0).wait(58).to({regX:-13,skewX:-2.3,skewY:-182.3,x:395.6,y:80},0).wait(2).to({regY:3.5,skewX:1.3,skewY:-178.7,x:396,y:79.1},0).wait(2).to({regX:-12.7,skewX:5,skewY:-175,x:396.2,y:78.2},0).wait(32).to({_off:true},12).wait(198));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_neck_2).wait(214).to({_off:false},0).wait(10).to({regX:-12.6,regY:3.4,skewX:-4.3,skewY:-184.3,x:395.6,y:85.9},0).wait(2).to({regX:-12.7,regY:3.5,skewX:-13.6,skewY:-193.6,x:395.1,y:93.7},0).wait(2).to({skewX:5,skewY:-175,x:396.2,y:78.2},0).wait(2).to({regY:3.4,skewX:9.3,skewY:-170.7,x:404.9,y:75.9},0).wait(2).to({regX:-12.6,regY:3.5,skewX:14,skewY:-166,x:413.5,y:73.8},0).wait(2).to({regX:-11.7,regY:3.7,skewX:23.3,skewY:-156.7,x:420.7,y:75.5},0).wait(2).to({regX:-12.6,regY:3.6,skewX:32.7,skewY:-147.3,x:429,y:77.4},0).wait(34).to({skewX:25.6,skewY:-154.4,x:426.8,y:80},0).wait(2).to({skewX:18.8,skewY:-161.2,x:424.6,y:82.6},0).wait(2).to({regY:3.8,skewX:16.3,skewY:-163.7,x:419.1,y:78.3},0).wait(2).to({regY:3.5,skewX:14,skewY:-166,x:413.5,y:73.8},0).wait(2).to({skewX:9.3,skewY:-170.7,x:404.9,y:76},0).wait(2).to({regX:-12.7,skewX:5,skewY:-175,x:396.2,y:78.2},0).wait(2).to({skewX:-8.1,skewY:-188.1,x:395.6,y:85.7},0).wait(2).to({regX:-13,skewX:-1.5,skewY:-181.5,x:396.1,y:81.9},0).wait(2).to({regX:-12.7,skewX:5,skewY:-175,x:396.2,y:78.2},0).wait(49).to({_off:true},62).wait(1));

	// Cheetah Hind Leg
	this.cheetah_hindleg = new lib.CheetahHindLeg();
	this.cheetah_hindleg.parent = this;
	this.cheetah_hindleg.setTransform(471.4,87.9,0.561,0.526,0,-22.6,157.4,-18.4,-47.2);
	this.cheetah_hindleg.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.cheetah_hindleg_1 = new lib.CheetahHindLeg_excited_001_1();
	this.cheetah_hindleg_1.parent = this;
	this.cheetah_hindleg_1.setTransform(471.4,87.9,0.561,0.526,0,-22.6,157.4,-18.4,-47.2);
	this.cheetah_hindleg_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.cheetah_hindleg_1._off = true;

	this.cheetah_hindleg_2 = new lib.CheetahHindLeg_excited_004_1();
	this.cheetah_hindleg_2.parent = this;
	this.cheetah_hindleg_2.setTransform(471.4,87.9,0.561,0.526,0,-22.6,157.4,-18.4,-47.2);
	this.cheetah_hindleg_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.cheetah_hindleg_3 = new lib.CheetahHindLeg_excited_005_1();
	this.cheetah_hindleg_3.parent = this;
	this.cheetah_hindleg_3.setTransform(471.4,87.9,0.561,0.526,0,-22.6,157.4,-18.4,-47.2);
	this.cheetah_hindleg_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.cheetah_hindleg_3._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cheetah_hindleg}]}).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},14).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},8).to({state:[{t:this.cheetah_hindleg}]},46).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},56).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},2).to({state:[{t:this.cheetah_hindleg}]},32).to({state:[{t:this.cheetah_hindleg}]},12).to({state:[{t:this.cheetah_hindleg_1}]},14).to({state:[{t:this.cheetah_hindleg_1}]},8).to({state:[{t:this.cheetah_hindleg_1}]},2).to({state:[{t:this.cheetah_hindleg_1}]},2).to({state:[{t:this.cheetah_hindleg_1}]},2).to({state:[{t:this.cheetah_hindleg_1}]},2).to({state:[{t:this.cheetah_hindleg_2,p:{regY:-47.2,scaleX:0.561,scaleY:0.526,skewX:-22.6,skewY:157.4,x:471.4,y:87.9}}]},2).to({state:[{t:this.cheetah_hindleg_2,p:{regY:-47.3,scaleX:0.577,scaleY:0.461,skewX:-37.6,skewY:163.7,x:466.5,y:104.1}}]},2).to({state:[{t:this.cheetah_hindleg_3}]},2).to({state:[{t:this.cheetah_hindleg_3}]},32).to({state:[{t:this.cheetah_hindleg_3}]},2).to({state:[{t:this.cheetah_hindleg_3}]},2).to({state:[{t:this.cheetah_hindleg_2,p:{regY:-47.3,scaleX:0.577,scaleY:0.461,skewX:-37.6,skewY:163.7,x:466.5,y:104.1}}]},2).to({state:[{t:this.cheetah_hindleg_2,p:{regY:-47.2,scaleX:0.561,scaleY:0.526,skewX:-22.6,skewY:157.4,x:471.4,y:87.9}}]},2).to({state:[{t:this.cheetah_hindleg_1}]},2).to({state:[{t:this.cheetah_hindleg_1}]},2).to({state:[{t:this.cheetah_hindleg_1}]},2).to({state:[{t:this.cheetah_hindleg_1}]},2).to({state:[{t:this.cheetah_hindleg_1}]},2).to({state:[{t:this.cheetah_hindleg_1}]},49).to({state:[]},62).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_hindleg).wait(2).to({scaleX:0.56,scaleY:0.53,skewY:157.5},0).wait(6).to({scaleX:0.56,scaleY:0.53,skewY:157.4},0).wait(16).to({scaleX:0.56,scaleY:0.53,skewY:157.5},0).wait(2).to({scaleX:0.56,scaleY:0.53,skewY:157.4},0).wait(2).to({scaleX:0.56,scaleY:0.53,skewY:157.5},0).wait(4).to({scaleX:0.56,scaleY:0.53,skewY:157.4},0).wait(56).to({scaleX:0.56,scaleY:0.53,skewY:157.5},0).wait(6).to({scaleX:0.56,scaleY:0.53,skewY:157.4},0).wait(58).to({scaleX:0.56,scaleY:0.53,skewY:157.5},0).wait(2).to({skewX:-22.5},0).wait(2).to({scaleX:0.56,scaleY:0.53,skewX:-22.6,skewY:157.4},0).wait(44).to({_off:true},14).wait(184));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_hindleg_1).wait(214).to({_off:false},0).wait(10).to({regY:-46.9,scaleX:0.56,scaleY:0.52,skewX:-22.8,skewY:157.9,x:471.6,y:89.2},0).wait(2).to({regY:-47.2,scaleY:0.51,skewX:-23.2,skewY:158.1,x:471.5,y:90.1},0).wait(2).to({regX:26.2,regY:66.3,scaleX:0.56,scaleY:0.53,skewX:-22.6,skewY:157.4,x:471.3,y:152.6},0).wait(2).to({regX:26.6,scaleY:0.45,skewX:-20.9,x:471,y:152.7},0).to({_off:true},2).wait(46).to({_off:false},0).wait(2).to({regX:26.2,scaleY:0.53,skewX:-22.6,x:471.3,y:152.6},0).wait(2).to({regX:-18.4,regY:-47.2,scaleX:0.56,scaleY:0.51,skewX:-23.2,skewY:158.1,x:471.5,y:90.1},0).wait(2).to({regX:-18.6,regY:-47.3,scaleY:0.52,skewX:-22.8,skewY:157.9,y:89.1},0).wait(2).to({regX:-18.4,regY:-47.2,scaleX:0.56,scaleY:0.53,skewX:-22.6,skewY:157.4,x:471.4,y:87.9},0).wait(49).to({_off:true},62).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_hindleg_3).wait(236).to({_off:false},0).wait(34).to({scaleX:0.56,scaleY:0.53,skewY:157.5},0).wait(2).to({scaleX:0.56,scaleY:0.53,skewY:157.4},0).to({_off:true},2).wait(124));

	// Cheetah Tail
	this.instance_12 = new lib.CheetahTail_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(479.4,82.4,0.588,0.588,0,5,-175,34.8,-47);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.instance_13 = new lib.CheetahTail_loop();
	this.instance_13.parent = this;
	this.instance_13.setTransform(479.4,82.5,0.588,0.588,0,-25,155,34.7,-47.1);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance_13._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(2).to({regX:34.5,regY:-47.2,skewX:-2.5,skewY:-182.5,x:479.6},0).wait(2).to({regX:34.8,regY:-47,skewX:-10,skewY:-190,x:479.4,y:82.5},0).wait(2).to({regX:34.4,regY:-47.2,skewX:-17.5,skewY:-197.5,x:479.5,y:82.3},0).to({_off:true},2).wait(24).to({_off:false,regX:34.8,regY:-47,skewX:5,skewY:-175,x:479.4,y:82.4},0).to({_off:true},2).wait(52).to({_off:false},0).wait(2).to({regX:34.5,regY:-47.2,skewX:-2.5,skewY:-182.5,x:479.6},0).wait(2).to({regX:34.8,regY:-47,skewX:-10,skewY:-190,x:479.4,y:82.5},0).wait(2).to({regX:34.4,regY:-47.2,skewX:-17.5,skewY:-197.5,x:479.5,y:82.3},0).to({_off:true},2).wait(62).to({_off:false,regX:34.8,regY:-47,skewX:5,skewY:-175,x:479.4,y:82.4},0).to({_off:true},2).wait(240));
	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(8).to({_off:false},0).wait(16).to({regX:34,x:479.8,y:82.2},0).wait(2).to({regX:34.7,x:479.4,y:82.5},0).wait(2).to({regY:-47,skewX:-15,skewY:165},0).wait(2).to({regX:34.6,skewX:-5,skewY:175,x:479.5,y:82.4},0).to({_off:true},2).wait(62).to({_off:false,regX:34.7,regY:-47.1,skewX:-25,skewY:155,x:479.4,y:82.5},0).wait(58).to({regY:-47,skewX:-15,skewY:165},0).wait(2).to({regX:34.8,regY:-47.1,skewX:-5,skewY:175,x:479.3},0).to({_off:true},2).wait(242));

	// Cheetah Tail
	this.instance_14 = new lib.CheetahTail_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(479.4,82.4,0.588,0.588,0,5,-175,34.8,-47);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance_14._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(34).to({_off:false},0).wait(6).to({_off:true},46).wait(72).to({_off:false},0).wait(42).to({_off:true},14).wait(54).to({_off:false,skewX:-47,skewY:-227,x:486.2,y:127},0).wait(2).to({regX:34.7,scaleX:0.59,scaleY:0.59,skewX:-46.9,skewY:-226.9,x:486.3},0).wait(2).to({regX:34.8,scaleX:0.59,scaleY:0.59,skewX:-47,skewY:-227,x:486.2},0).wait(2).to({regY:-46.8,skewX:-27.3,skewY:-207.3,x:486,y:111.6},0).wait(2).to({regX:35.1,regY:-47.1,skewX:-8,skewY:-188,x:485.7,y:95.8},0).wait(2).to({regX:35.4,regY:-47.2,skewX:-1.3,skewY:-181.3,x:482.3,y:89.1},0).wait(2).to({regX:34.8,regY:-47,skewX:5,skewY:-175,x:479.4,y:82.4},0).wait(2).to({regX:33.4,regY:-47.4,skewX:3,skewY:-177,x:479.1,y:83.3},0).wait(2).to({regX:33.3,skewX:4,skewY:-176,x:479.4,y:82.9},0).wait(2).to({regX:34.8,regY:-47,skewX:5,skewY:-175,y:82.4},0).wait(49).to({_off:true},62).wait(1));

	// Cheetah Torso
	this.cheetah_torso = new lib.CheetahTorso();
	this.cheetah_torso.parent = this;
	this.cheetah_torso.setTransform(407.5,86.7,0.588,0.588,0,5,-175,46.4,-0.6);
	this.cheetah_torso.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.cheetah_torso_1 = new lib.CheetahTorso_wet();
	this.cheetah_torso_1.parent = this;
	this.cheetah_torso_1.setTransform(407.5,86.7,0.588,0.588,0,5,-175,46.4,-0.6);
	this.cheetah_torso_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.cheetah_torso_2 = new lib.CheetahTorso_excited_001_1();
	this.cheetah_torso_2.parent = this;
	this.cheetah_torso_2.setTransform(407.5,86.7,0.588,0.588,0,5,-175,46.4,-0.6);
	this.cheetah_torso_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.cheetah_torso_2._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cheetah_torso}]}).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},14).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},8).to({state:[{t:this.cheetah_torso}]},46).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},56).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},2).to({state:[{t:this.cheetah_torso}]},32).to({state:[{t:this.cheetah_torso_1}]},12).to({state:[{t:this.cheetah_torso_2}]},14).to({state:[{t:this.cheetah_torso_2}]},8).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},32).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},2).to({state:[{t:this.cheetah_torso_2}]},49).to({state:[]},62).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_torso).wait(2).to({regX:46.2,regY:-0.5,skewX:4.5,skewY:-175.5,y:87.1},0).wait(2).to({regX:46.4,regY:-0.6,skewX:4.3,skewY:-175.7,x:407.4,y:87.4},0).wait(2).to({regX:46.5,regY:-0.3,skewX:4,skewY:-176,x:407.2,y:87.9},0).wait(2).to({regY:-0.5,skewX:3.8,skewY:-176.2,x:407.3,y:88.1},0).wait(20).to({regY:-0.6,skewX:4.1,skewY:-175.9,y:87.6},0).wait(2).to({regX:46.4,regY:-0.5,skewX:4.5,skewY:-175.5,x:407.4,y:87.1},0).wait(2).to({regY:-0.6,skewX:5,skewY:-175,x:407.5,y:86.7},0).wait(56).to({regX:46.2,regY:-0.5,skewX:4.5,skewY:-175.5,y:87.1},0).wait(2).to({regX:46.4,regY:-0.6,skewX:4.3,skewY:-175.7,x:407.4,y:87.4},0).wait(2).to({regX:46.5,regY:-0.3,skewX:4,skewY:-176,x:407.2,y:87.9},0).wait(2).to({regY:-0.5,skewX:3.8,skewY:-176.2,x:407.3,y:88.1},0).wait(58).to({regY:-0.6,skewX:4.1,skewY:-175.9,y:87.6},0).wait(2).to({regX:47.8,regY:-0.3,skewX:4.5,skewY:-175.5,x:406.6,y:87.3},0).wait(2).to({regX:46.4,regY:-0.6,skewX:5,skewY:-175,x:407.5,y:86.7},0).wait(32).to({_off:true},12).wait(198));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_torso_2).wait(214).to({_off:false},0).wait(10).to({regX:46.5,regY:-0.5,scaleX:0.6,skewX:1.3,skewY:-178.7,x:407.4,y:93},0).wait(2).to({regX:46.4,regY:-0.3,scaleX:0.6,skewX:-2.3,skewY:-182.3,y:99.2},0).wait(2).to({regY:-0.6,scaleX:0.59,skewX:5,skewY:-175,x:407.5,y:86.7},0).wait(2).to({regX:46.5,regY:-0.5,skewX:14.3,skewY:-165.7,x:414.9,y:85.7},0).wait(2).to({regX:46.1,regY:-0.6,skewX:23.7,skewY:-156.3,x:422.5,y:84.7},0).wait(2).to({regY:-0.7,skewX:34.8,skewY:-145.2,x:427.7,y:87.1},0).wait(2).to({regX:46.9,regY:-0.6,skewX:45.9,skewY:-134.1,x:432.8,y:89.5},0).wait(34).to({regX:47,scaleX:0.59,scaleY:0.59,skewX:43.9,skewY:-136.1,x:431.5,y:91.4},0).wait(2).to({regX:46.6,scaleX:0.59,scaleY:0.59,skewX:41.9,skewY:-138.1,x:430.3,y:93.5},0).wait(2).to({regX:46.2,regY:-0.5,skewX:32.8,skewY:-147.2,x:426.6,y:89.3},0).wait(2).to({regX:46.1,regY:-0.6,skewX:23.7,skewY:-156.3,x:422.5,y:84.7},0).wait(2).to({regX:46,regY:-0.5,skewX:14.3,skewY:-165.7,x:415,y:85.8},0).wait(2).to({regX:46.4,regY:-0.6,skewX:5,skewY:-175,x:407.5,y:86.7},0).wait(2).to({regX:46.5,scaleX:0.6,skewX:3.2,skewY:-176.8,x:407.2,y:92.2},0).wait(2).to({regX:46.6,regY:-0.5,scaleX:0.59,skewX:4,skewY:-176,x:407.3,y:89.6},0).wait(2).to({regX:46.4,regY:-0.6,scaleX:0.59,skewX:5,skewY:-175,x:407.5,y:86.7},0).wait(49).to({_off:true},62).wait(1));

	// Cheetah Tail
	this.instance_15 = new lib.CheetahTail_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(479.4,82.4,0.588,0.588,0,5,-175,34.8,-47);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance_15._off = true;

	this.instance_16 = new lib.CheetahTail_loop();
	this.instance_16.parent = this;
	this.instance_16.setTransform(486.2,127,0.588,0.588,0,-47,133,34.8,-47);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_15}]},214).to({state:[{t:this.instance_15}]},8).to({state:[{t:this.instance_15}]},2).to({state:[{t:this.instance_15}]},2).to({state:[{t:this.instance_15}]},2).to({state:[{t:this.instance_15}]},2).to({state:[{t:this.instance_15}]},2).to({state:[{t:this.instance_15}]},2).to({state:[{t:this.instance_16}]},2).to({state:[]},32).to({state:[]},129).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(214).to({_off:false},0).wait(10).to({regX:34.9,regY:-46.9,skewX:4,skewY:-176,x:479.2,y:82.9},0).wait(2).to({regX:33.4,regY:-47.4,skewX:3,skewY:-177,x:479.1,y:83.3},0).wait(2).to({regX:34.8,regY:-47,skewX:5,skewY:-175,x:479.4,y:82.4},0).wait(2).to({regX:34.7,regY:-46.9,skewX:-1.3,skewY:-181.3,x:482.6,y:89.2},0).wait(2).to({regX:35.1,regY:-47.1,skewX:-8,skewY:-188,x:485.7,y:95.8},0).wait(2).to({regX:35,skewX:-27.3,skewY:-207.3,x:486,y:111.4},0).to({_off:true},2).wait(162));

	// Hind Leg (Back)
	this.cheetah_hindlegback = new lib.HindLegBack();
	this.cheetah_hindlegback.parent = this;
	this.cheetah_hindlegback.setTransform(466.9,88.8,0.548,0.548,0,5,-175,-33.9,-40.2);
	this.cheetah_hindlegback.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.cheetah_hindlegback_1 = new lib.HindLegBack_excited_001_1();
	this.cheetah_hindlegback_1.parent = this;
	this.cheetah_hindlegback_1.setTransform(461.9,144.8,0.548,0.548,0,5,-175,-33.6,62.4);
	this.cheetah_hindlegback_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);
	this.cheetah_hindlegback_1._off = true;

	this.cheetah_hindlegback_2 = new lib.HindLegBack_excited_005_1();
	this.cheetah_hindlegback_2.parent = this;
	this.cheetah_hindlegback_2.setTransform(466.9,88.8,0.548,0.548,0,5,-175,-33.9,-40.2);
	this.cheetah_hindlegback_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);
	this.cheetah_hindlegback_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.cheetah_hindlegback).wait(2).to({regX:-34,regY:-40.1,skewX:4.8,skewY:-175.2,x:467},0).wait(6).to({regX:-33.9,regY:-40.2,skewX:5,skewY:-175,x:466.9},0).wait(16).to({regX:-34,regY:-40.1,skewX:4.8,skewY:-175.2,x:467},0).wait(2).to({regX:-33.9,regY:-40.2,skewX:5,skewY:-175,x:466.9},0).wait(2).to({regX:-34,regY:-40.1,skewX:4.8,skewY:-175.2,x:467},0).wait(4).to({regX:-33.9,regY:-40.2,skewX:5,skewY:-175,x:466.9},0).wait(56).to({regX:-34,regY:-40.1,skewX:4.8,skewY:-175.2,x:467},0).wait(6).to({regX:-33.9,regY:-40.2,skewX:5,skewY:-175,x:466.9},0).wait(58).to({regX:-34,regY:-40.1,skewX:4.8,skewY:-175.2,x:467},0).wait(2).to({regX:-33.9},0).wait(2).to({regY:-40.2,skewX:5,skewY:-175,x:466.9},0).wait(44).to({_off:true},14).wait(184));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_hindlegback_1).wait(214).to({_off:false},0).wait(10).to({regY:62.6,scaleY:0.54,skewY:-175.2,y:145.1},0).wait(2).to({regX:-33.7,regY:62.5,scaleY:0.53,skewX:5.3},0).wait(2).to({regX:-33.6,regY:62.4,scaleY:0.55,skewX:5,skewY:-175,y:144.8},0).wait(2).to({regX:-33.7,regY:62.3,scaleY:0.51,skewX:4.8,skewY:-175.2,x:462,y:144.7},0).wait(2).to({regX:-33.6,scaleY:0.47,skewX:5,skewY:-175,x:461.9},0).wait(2).to({regY:62.2,scaleX:0.62,scaleY:0.37,skewX:14.9,skewY:-176.7,x:462.2,y:146.8},0).to({_off:true},2).wait(38).to({_off:false},0).wait(2).to({regY:62.3,scaleX:0.55,scaleY:0.47,skewX:5,skewY:-175,x:461.9,y:144.7},0).wait(2).to({scaleY:0.51,skewX:4.8,skewY:-175.2,y:144.8},0).wait(2).to({regY:62.4,scaleY:0.55,skewX:5,skewY:-175},0).wait(2).to({regX:-33.7,regY:62.5,scaleY:0.53,skewX:5.3,skewY:-175.2,y:145.1},0).wait(2).to({regY:62.6,scaleY:0.54,skewX:5,y:145},0).wait(2).to({regX:-33.6,regY:62.4,scaleY:0.55,skewY:-175,y:144.8},0).wait(49).to({_off:true},62).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_hindlegback_2).wait(236).to({_off:false},0).wait(34).to({regX:-34,regY:-40.1,skewX:4.8,skewY:-175.2,x:467},0).wait(2).to({regX:-33.9,regY:-40.2,skewX:5,skewY:-175,x:466.9},0).to({_off:true},2).wait(124));

	// Front Leg Back
	this.cheetah_frontlegback = new lib.FrontLegBack();
	this.cheetah_frontlegback.parent = this;
	this.cheetah_frontlegback.setTransform(401.7,82.2,0.588,0.588,0,5,-175,-8,-44.3);
	this.cheetah_frontlegback.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.cheetah_frontlegback_1 = new lib.CheetahLegB_096_1();
	this.cheetah_frontlegback_1.parent = this;
	this.cheetah_frontlegback_1.setTransform(404.3,97.4,1,1,21,0,0,11.5,26.6);
	this.cheetah_frontlegback_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.cheetah_frontlegback}]}).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},14).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},8).to({state:[{t:this.cheetah_frontlegback}]},46).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},56).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},32).to({state:[{t:this.cheetah_frontlegback}]},12).to({state:[{t:this.cheetah_frontlegback}]},14).to({state:[{t:this.cheetah_frontlegback}]},8).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback_1,p:{regX:11.5,regY:26.6,rotation:21,x:404.3,y:97.4}}]},2).to({state:[{t:this.cheetah_frontlegback_1,p:{regX:11.9,regY:26.8,rotation:-6.9,x:424.1,y:103.1}}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},32).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback_1,p:{regX:11.9,regY:26.8,rotation:-6.9,x:424.1,y:103.1}}]},2).to({state:[{t:this.cheetah_frontlegback_1,p:{regX:11.5,regY:26.6,rotation:21,x:404.3,y:97.4}}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},2).to({state:[{t:this.cheetah_frontlegback}]},49).to({state:[]},62).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.cheetah_frontlegback).wait(2).to({scaleY:0.58,skewY:-175.2,y:82.8},0).wait(2).to({regX:-9,regY:-44.4,scaleY:0.58,x:402.3,y:83.6},0).wait(2).to({regX:-8.1,regY:-44.2,scaleY:0.57,x:401.7,y:84.2},0).wait(2).to({regX:-8,regY:-44.3,scaleY:0.56,skewX:5.2,y:84.8},0).wait(16).to({regY:-44.2,skewX:5.1,y:84.9},0).wait(2).to({regY:-44.3,skewX:5.2,y:84.8},0).wait(2).to({regY:-44.4,scaleY:0.57,skewX:5,x:401.8,y:83.9},0).wait(2).to({regY:-44.2,scaleY:0.58,y:83},0).wait(2).to({regY:-44.3,scaleY:0.59,skewY:-175,x:401.7,y:82.2},0).wait(56).to({scaleY:0.58,skewY:-175.2,y:82.8},0).wait(2).to({regX:-9,regY:-44.4,scaleY:0.58,x:402.3,y:83.6},0).wait(2).to({regX:-8.1,regY:-44.2,scaleY:0.57,x:401.7,y:84.2},0).wait(2).to({regX:-8,regY:-44.3,scaleY:0.56,skewX:5.2,y:84.8},0).wait(58).to({regY:-44.4,scaleY:0.57,skewX:5,x:401.8,y:83.9},0).wait(2).to({regY:-44.3,scaleY:0.58,y:83.1},0).wait(2).to({scaleY:0.59,skewY:-175,x:401.7,y:82.2},0).wait(68).to({regX:-8.6,regY:-43.9,scaleX:0.59,scaleY:0.53,skewX:2.3,skewY:-175.5,x:400.2,y:88.2},0).wait(2).to({regX:-8,regY:-44.5,scaleX:0.59,scaleY:0.47,skewX:-0.1,skewY:-175.8,x:397.8,y:93.6},0).wait(2).to({regY:-44.3,scaleX:0.59,scaleY:0.59,skewX:5,skewY:-175,x:401.7,y:82.2},0).wait(2).to({regX:-7.9,regY:-44.2,skewX:10,skewY:-170,x:409.1,y:79.8},0).to({_off:true},2).wait(4).to({_off:false,regX:-8,regY:-44.6,scaleX:0.6,skewX:-4.9,skewY:-175.1,x:429.5,y:84},0).wait(34).to({scaleX:0.6,scaleY:0.58,skewX:-5.6,skewY:-175.2,x:428.8,y:85.4},0).wait(2).to({regY:-44.4,scaleY:0.56,skewX:-6.5,skewY:-175.3,x:428,y:86.8},0).to({_off:true},2).wait(4).to({_off:false,regX:-7.9,regY:-44.2,scaleX:0.59,scaleY:0.59,skewX:10,skewY:-170,x:409.1,y:79.8},0).wait(2).to({regX:-8,regY:-44.3,skewX:5,skewY:-175,x:401.7,y:82.2},0).wait(2).to({regY:-44.4,scaleX:0.59,scaleY:0.51,skewX:2.1,skewY:-175.5,x:399.8,y:89.7},0).wait(2).to({regY:-44.6,scaleY:0.55,skewX:3.5,skewY:-175.2,x:400.8,y:86},0).wait(2).to({regY:-44.3,scaleX:0.59,scaleY:0.59,skewX:5,skewY:-175,x:401.7,y:82.2},0).wait(49).to({_off:true},62).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(349.8,46.1,184.8,126.3);


// stage content:
(lib.MWcheetah = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWcheetah_atlas_.png?1528311458096", id:"MWcheetah_atlas_"}
	],
	preloads: []
};




})(lib_Cheetah = lib_Cheetah||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Cheetah, images, createjs, ss, AdobeAn;